/**
 * Supplier logins (access level 4) — now one case of `partnerAccess.ts`.
 *
 * Kept as a thin re-export so existing imports and `supplierAccess.test.ts`
 * keep working until every import moves to `partnerAccess`.
 */
import {
  PARTNER_PORTALS,
  partnerForAccessLevel,
  partnerForPortalPath,
  partnerRedirectFor,
} from "./partnerAccess.ts";

export {
  ACCESS_LEVEL_SUPPLIER,
  STAFF_HOME_AFTER_SIGN_IN,
  homePathAfterSignIn,
  postLoginPath,
  safeReturnPath,
} from "./partnerAccess.ts";

/** Where a supplier lands, and where any staff URL sends them. */
export const SUPPLIER_HOME = PARTNER_PORTALS.supplier.home;

export function isSupplierAccessLevel(accessLevel: number | null | undefined): boolean {
  return partnerForAccessLevel(accessLevel) === "supplier";
}

/** True for the supplier portal's own paths: `/supplier` and `/supplier/…` (not `/supplier-orders`). */
export function isSupplierPortalPath(pathname: string): boolean {
  return partnerForPortalPath(pathname) === "supplier";
}

/** @deprecated Use `partnerRedirectFor` — it covers every partner login. */
export const supplierRedirectFor = partnerRedirectFor;
